/**
 * Base path for the supportfrontend live-chat (Support Chat) proxy routes.
 *
 * copilot-ui's live-chat layer is transport-agnostic and ships no default base
 * path, so supportfrontend owns this value and passes it in via the
 * CopilotProvider `liveChat.basePath` prop and `useActiveConversation`.
 */
export const SUPPORT_CHAT_API_BASE_PATH =
  "/api/supportfrontend/v1/proxy/support-chat";
